import { fetchAllPages } from '../../../utils/fetchAllPages';
import { UserAdapters } from '../adapters';
import { INTERNAL_USERS_MAX_LIMIT, UsersApi } from '../clients';

const readData = (response) => response?.data;

/**
 * Every GoTu admin, of every role, as picker options keyed by internal_user row
 * id (see `toGotuAdminOptionViewEntity`).
 *
 * Paged to exhaustion at the server's maximum page size: auth-service has no
 * `ids` filter, so resolving a metro's assigned ids to names, and offering every
 * admin to assign, both need the whole list. Ordered by first name, the
 * client's default. First names repeat (and some are null), but auth-service
 * breaks every sort on `iu.id` (`internal/sqlstore/postgres/internal-user/get.go`,
 * "iu.id breaks ties so paging is deterministic"), so the pages fetched in
 * parallel neither overlap nor skip an admin.
 *
 * @returns {Promise<import('../types/User').IGotuAdminOptionViewEntity[]>}
 */
export const getAllInternalUsers = async () => {
  const rows = await fetchAllPages(UsersApi.getInternalUsers, {
    limit: INTERNAL_USERS_MAX_LIMIT,
    getItems: readData,
  });

  return rows.map(UserAdapters.toGotuAdminOptionViewEntity);
};
